import React from "react";
import { Button, Drawer, Space, Spin, Table, Tag } from "antd";
import { DeleteOutlined, EditOutlined, PlusOutlined } from "@ant-design/icons";
import { connect } from "react-redux";
import Base from "../Base";
import { getUserInfo } from "../../utils/redux/reducers/User";
import EditBuildingForm from "./EditBuildingForm";

class BuildingManagement extends Base {
  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      buildings: [],
      buildingData: null,
      loading: false,
      formLoading: false,
    };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible && !this.props.visible) {
      this.setState({ buildingData: null });
    }

    if (
      this.props.community &&
      this.props.visible &&
      (!prevProps.visible ||
        prevProps.community?.id !== this.props.community?.id)
    ) {
      this.onGetBuildingList();
    }
  }

  onGetBuildingList = async () => {
    const { community } = this.props;
    const token = this.getUserToken();
    if (!token || !community?.id) return;

    const api = this.api.communityBuilding.list;
    const apiConfig = {
      token,
      path: { community_id: community.id },
    };

    try {
      this.setState({ loading: true });
      const res = await api.run(apiConfig);
      if (!this.mounted) return;
      if (res.result) {
        this.setState({ buildings: res.data || [] });
      } else {
        this.showMessage(res.message, Base.Message.error);
      }
    } catch (error) {
      if (!this.mounted) return;
      this.handleApiError(api, error);
    } finally {
      if (!this.mounted) return;
      this.setState({ loading: false });
    }
  };

  onFinishForm = async (values) => {
    const { community } = this.props;
    const token = this.getUserToken();
    if (!token || !community?.id) return;

    const { buildingData } = this.state;
    let api = this.api.communityBuilding.add;
    const apiConfig = {
      token,
      path: { community_id: community.id },
      data: {
        zh_name: values.zh_name,
        ug_name: values.ug_name,
        order:
          values.order !== undefined && values.order !== ""
            ? Number(values.order)
            : 0,
        enabled: values.enabled ? 1 : 0,
      },
    };

    if (buildingData && buildingData.id) {
      api = this.api.communityBuilding.update;
      apiConfig.path = {
        community_id: community.id,
        id: buildingData.id,
      };
    }

    this.setState({ formLoading: true });
    try {
      const res = await api.run(apiConfig);
      if (!this.mounted) return;
      if (res.result) {
        this.setState({ buildingData: null });
        this.onGetBuildingList();
      } else {
        this.showMessage(res.message, Base.Message.error);
      }
    } catch (error) {
      if (!this.mounted) return;
      this.handleApiError(api, error);
    } finally {
      if (!this.mounted) return;
      this.setState({ formLoading: false });
    }
  };

  onAddBuilding = () => {
    this.setState({ buildingData: {} });
  };

  onEditBuilding = (buildingData) => {
    this.setState({ buildingData });
  };

  onCancelForm = () => {
    this.setState({ buildingData: null });
  };

  onDeleteBuilding = (id) => {
    const { community } = this.props;
    this.showModal(
      this.i18n.t("sales.deleteWarning"),
      Base.Modal.confirm,
      async () => {
        const token = this.getUserToken();
        if (!token || !community?.id) return;

        const api = this.api.communityBuilding.delete;
        const apiConfig = {
          token,
          path: { community_id: community.id, id },
        };

        try {
          const res = await api.run(apiConfig);
          if (res.result) {
            this.onGetBuildingList();
          } else {
            this.showMessage(res.message);
          }
        } catch (error) {
          if (!this.mounted) return;
          this.handleApiError(api, error);
        }
      }
    );
  };

  render() {
    const { visible, onClose, community } = this.props;
    const { buildings, buildingData, loading, formLoading } = this.state;

    return (
      <>
        <Drawer
          title={`${this.i18n.t("communityBuilding.title")} - ${community?.zh_name || ""}`}
          width={720}
          open={visible}
          onClose={onClose}
          destroyOnClose
        >
          <Spin spinning={loading}>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={this.onAddBuilding}
              style={{ marginBottom: 16 }}
            >
              {this.i18n.t("communityBuilding.add")}
            </Button>
            <Table
              dataSource={buildings}
              rowKey="id"
              pagination={false}
              columns={[
                {
                  title: this.i18n.t("communityBuilding.zhName"),
                  dataIndex: "zh_name",
                  key: "zh_name",
                },
                {
                  title: this.i18n.t("communityBuilding.ugName"),
                  dataIndex: "ug_name",
                  key: "ug_name",
                },
                {
                  title: this.i18n.t("community.order"),
                  dataIndex: "order",
                  key: "order",
                },
                {
                  title: this.i18n.t("communityBuilding.enabled"),
                  dataIndex: "enabled",
                  key: "enabled",
                  render: (enabled) => (
                    <Tag color={enabled ? "green" : "default"}>
                      {enabled
                        ? this.i18n.t("communityBuilding.enabledYes")
                        : this.i18n.t("communityBuilding.enabledNo")}
                    </Tag>
                  ),
                },
                {
                  title: this.i18n.t("users.actions"),
                  key: "actions",
                  render: (_, item) => (
                    <Space>
                      <Button
                        type="link"
                        icon={<EditOutlined />}
                        onClick={() => this.onEditBuilding(item)}
                      />
                      <Button
                        type="link"
                        danger
                        icon={<DeleteOutlined />}
                        onClick={() => this.onDeleteBuilding(item.id)}
                      />
                    </Space>
                  ),
                },
              ]}
            />
          </Spin>
        </Drawer>
        <EditBuildingForm
          buildingData={buildingData}
          onCancel={this.onCancelForm}
          onFinish={this.onFinishForm}
          loading={formLoading}
        />
      </>
    );
  }
}

export default connect((state) => ({
  user: getUserInfo(state),
}))(BuildingManagement);
